export default "__VITE_ASSET__C4awxJvT__"